import { FC, PropsWithChildren } from "react";
import { Button, Buttons, Modal } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import "./ConditionalErrorModal.scss";


interface ConditionalErrorModalProps {
  isVisible: boolean;
  title: string;
  onClose: (canContinue: boolean) => void;
  approveText?: string;
  denyText?: string;
  canContinue?: boolean;
}

export const ConditionalErrorModal: FC<PropsWithChildren<ConditionalErrorModalProps>> = (props) => {
  const { isVisible, title, onClose, approveText = "Continue", denyText = "Deny", children, canContinue = false } = props;

  return (
    <Modal
      title={title}
      visible={isVisible}
      onClose={() => onClose(false)}
      footer={
        <Shelf spacing={canContinue ? "small" : undefined}>
          <Shelf.Spacer />
          {canContinue && (
            <Button className="enrollment-modal-button" appearance={Buttons.Functional.Secondary.Large} onClick={() => onClose(false)}>
              {denyText}
            </Button>
          )}
          <Button className="enrollment-modal-button" appearance={Buttons.Functional.Primary.Large} onClick={() => onClose(canContinue)}>
            {canContinue ? approveText : denyText}
          </Button>
        </Shelf>
      }
    >
      {children}
    </Modal>
  );
};
